<div class="container" [ngClass]="{ mobile: (isMobile$ | async) }">
  <section class="faq__search" [formGroup]="searchForm">
    <h2 class="mat-headline-3 align-center">{{ 'WM_TECH.MAIN.FAQ' | translate }}</h2>

    <div class="faq__search-block" (wmLibsClickOutside)="onOutsideClick()">
      <mat-form-field appearance="outline" class="wm-input wm-input--no-validation">
        <input formControlName="searchControl" matInput [placeholder]="'main.search' | translate" type="string" />
      </mat-form-field>

      <div class="finded" *ngIf="findedFaq?.length">
        <div class="finded_wrapper">
          <div class="faq" *ngFor="let item of findedFaq">
            <div class="faq-item-option" (click)="selectFaq(item.item)" [innerHTML]="item.finded"></div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="faq__answers mb-2">
    <div *ngIf="selectedFaq" class="tutorial-section">
      <div class="tutorial-inner">
        <h2>
          {{ selectedFaq[this.tr.currentLang === 'en' ? 'question_en' : 'question_ru'] | translate }}
        </h2>
        <p [innerHTML]="selectedFaq[this.tr.currentLang === 'en' ? 'answer_en' : 'answer_ru'] | translate"></p>
      </div>
    </div>
  </section>

  <section class="faq__questions">
    <div class="wm-main-card wm-main-card-padding" *ngIf="faqList; else faqLoadingTemplate">
      <div class="faq__section">
        <div class="faq__block">
          <div class="faq__block-inner" *ngFor="let faqListItem of faqList">
            <h3 class="bold">
              {{ faqListItem[this.tr.currentLang === 'en' ? 'title_en' : 'title_ru'] }}
            </h3>
            <p *ngFor="let faq of faqListItem.faqs" (click)="selectFaq(faq)" [ngClass]="{ active: faq === selectedFaq }">
              {{ this.tr.currentLang === 'en' ? faq['question_en'] : faq['question_ru'] }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>

<ng-template #faqLoadingTemplate>
  <div class="dashboard-card wm-loading" style="height: 50vh"></div>
</ng-template>
